import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IBatchItemReturn } from "../../../model/ItemModel";
import { BatchActionInnerBody } from "./BatchActionInnerBody";
import { BatchActionTab } from "./BatchActionTab/BatchActionTab";
import { BatchTabPanel } from "./BatchTabPanel";

interface IBatchActionBody {
    aprovedFiles: IBatchItemReturn[];
    reprovedFiles: IBatchItemReturn[];
    handleChange: (event: React.SyntheticEvent, newValue: number) => void;
    value: number;
}

export const BatchActionBody : React.FC<IBatchActionBody> = ({
    aprovedFiles,
    reprovedFiles,
    handleChange,
    value
}) => {

    const { t } = useTranslation();

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <BatchActionTab
                    handleChange={handleChange}
                    value={value}
                /> 
            </Box>
            <BatchTabPanel value={value} index={0}>
                <BatchActionInnerBody 
                    files={aprovedFiles}
                    index={0}
                    type="APPROVED"
                    value={0}
                />
            </BatchTabPanel>
            <BatchTabPanel value={value} index={1}>
                <BatchActionInnerBody 
                    files={reprovedFiles}
                    index={1}
                    type="REPROVED"
                    value={1}
                />
            </BatchTabPanel>
        </Box>
    )
}